import { Route, Redirect } from 'react-router-dom';
import Auth from './Auth';

function ProtectedRoute({ component: Component, role: userRole, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) => {
        const token = localStorage.getItem('token');
        const role = localStorage.getItem('role');
        const isPermitted = userRole.includes(role);

        // return <Component {...props} />

        if ((token || Auth.isAuthenticated()) && isPermitted) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: '/signin',
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
}

export default ProtectedRoute;
